/**
 * Product Card — Colapsar swatches de color (PLP) — Ivonne
 * --------------------------------------------------------------
 * En el PLP, los productos con muchos colores encimaban los
 * swatches. Aqui limitamos a 3 visibles y agregamos un "+N" con el
 * resto. Al hacer click en "+N" se abre el PDP del producto.
 *
 * - Solo colapsa en PLP (contenedor dentro de .product-card).
 *   En el PDP se muestran todos los colores (solo aplican estilos).
 * - Idempotente por contenedor (flag dataset).
 * - Re-procesa en el AJAX de Prestige via MutationObserver.
 */
(function () {
  'use strict';

  var FLAG = 'variantsCollapsed';
  var MAX_VISIBLE = 3;
  var SWATCH_SEL = '.shpflt-product-variants';

  function productUrl(card) {
    var link = card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href') : null;
  }

  function collapse(container) {
    if (!container || container.nodeType !== 1) return;
    if (container.dataset[FLAG] === 'true') return;

    // Solo PLP: el contenedor debe vivir dentro de una .product-card.
    var card = container.closest ? container.closest('.product-card') : null;
    if (!card) return;

    var swatches = container.querySelectorAll(SWATCH_SEL);

    // Marcamos ANTES de insertar nada (evita reentrancia del observer).
    container.dataset[FLAG] = 'true';

    if (swatches.length <= MAX_VISIBLE) return; // no hace falta colapsar

    var hidden = swatches.length - MAX_VISIBLE;

    for (var i = MAX_VISIBLE; i < swatches.length; i++) {
      swatches[i].style.display = 'none';
    }

    // Si la card entera ya es un <a>, dejamos que ese link navegue
    // (evita anidar <a> dentro de <a>, HTML invalido). Si no, creamos
    // nuestro propio enlace al PDP.
    var insideLink = container.closest ? container.closest('a') : null;
    var more;
    if (insideLink) {
      more = document.createElement('span');
    } else {
      more = document.createElement('a');
      var url = productUrl(card);
      if (url) more.setAttribute('href', url);
    }
    more.className = 'shpflt-product-variants__more';
    more.textContent = '+' + hidden;

    container.appendChild(more);
  }

  function processIn(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var swatches = scope.querySelectorAll(SWATCH_SEL);
    var seen = [];
    for (var i = 0; i < swatches.length; i++) {
      var parent = swatches[i].parentNode;
      if (parent && seen.indexOf(parent) === -1) {
        seen.push(parent);
        collapse(parent);
      }
    }
  }

  // --- Pasada inicial -----------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { processIn(document); });
  } else {
    processIn(document);
  }

  // --- Re-init en cambios de DOM (paginacion/facets/sort AJAX) ------------
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        processIn(node);
      }
    }
  });

  function startObserving() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();